import api from 'plugin/api';

/**
 *  @description 제품주기 API
 */
async function prdtCycleList(params) {
  const url = '/sfsh/monitoring/prdtCycleList';

  const response = await api.get(url, { params });
  return response;
}

/**
 *  @description 제품주기상세 - 목록API
 */
async function prdtCycleResultList(params) {
  const url = '/sfsh/inspection/result';

  const response = await api.get(url, { params });
  return response;
}

/**
 *  @description 미의뢰내역 건수 API
 */
async function unrequestInfo(params) {
  const url = '/sfsh/monitoring/unrequest/cnt';

  const response = await api.get(url, { params });
  return response;
}

/**
 *  @description 미의뢰내역 자세히보기 - 목록 API
 */
async function unrequestList(params) {
  const url = '/sfsh/monitoring/unrequest';

  const response = await api.get(url, { params });
  return response;
}

/**
 *  @description 미의뢰내역 자세히보기 - 상세 API
 */
async function unrequestDetail(seq) {
  const url = `/sfsh/monitoring/unrequest/${seq}`;

  const response = await api.get(url);
  return response;
}

/**
 *  @description 미의뢰내역 자세히보기 - 등록 API
 */

async function unrequestCreate(seq, requestBody) {
  const url = `/sfsh/monitoring/unrequest/${seq}`;

  const response = await api.post(url, requestBody);
  return response;
}

/**
 *  @description 미의뢰내역 자세히보기 - 미의뢰사유이력 API
 */
async function unrequestComments(seq) {
  const url = `/sfsh/monitoring/unrequest/${seq}/comments`;

  const response = await api.get(url);
  return response;
}

export {
  prdtCycleList,
  prdtCycleResultList,
  unrequestInfo,
  unrequestList,
  unrequestDetail,
  unrequestCreate,
  unrequestComments
};
